import {fetchAPI} from "api";
import * as CountryConstants from "../../countries/constants/Countries";
import {handleResponse} from "helpers/Requests";

function fetchCountries() {
  return dispatch => {
    dispatch(fetchCountriesStarted());
    return fetchAPI('/web/v1/countries')
      .then(handleResponse())
      .then(
        (response) => {
          dispatch(fetchCountriesCompleted(response.content));
        }
      );
  };
}

function fetchCountriesStarted() {
  return {
    type: CountryConstants.FETCH_COUNTRIES_STARTED
  };
}

function fetchCountriesCompleted(countries) {
  return {
    type: CountryConstants.FETCH_COUNTRIES_COMPLETED,
    countries: countries
  };
}

export {
  fetchCountries
};
